import { postData } from "../api/api";
import type { Widget } from "../types/widget";

export const adminWidgetService = {
  approveIndex: (id: string) =>
    postData(`/admin/widgets/${id}/approve-index`, {}) as Promise<Widget>,

  rejectIndex: (id: string) =>
    postData(`/admin/widgets/${id}/reject-index`, {}) as Promise<Widget>,
};
